(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4076],{

/***/ 49021:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/forgot-password",
      function () {
        return __webpack_require__(27397);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 65345:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 88054:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(65345),
    de: __webpack_require__(76419)
};


/***/ }),

/***/ 78610:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 16709:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: common  } = __webpack_require__(31668);
module.exports = {
    ...common,
    "forgot-password-form": __webpack_require__(42134)
};


/***/ }),

/***/ 1943:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(16709),
    de: __webpack_require__(78610)
};


/***/ }),

/***/ 27397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ forgot_password; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageTitle/index.js
var PageTitle = __webpack_require__(73446);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js + 3 modules
var SimpleTemplate = __webpack_require__(35449);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/Title.js
var Title = __webpack_require__(70504);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/Description.js
var Description = __webpack_require__(94746);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./src/SiteLayout/index.js + 5 modules
var SiteLayout = __webpack_require__(3918);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Spinner/index.js + 1 modules
var Spinner = __webpack_require__(39116);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/SmartForm/index.js + 8 modules
var SmartForm = __webpack_require__(3816);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/useTracking/index.js
var useTracking = __webpack_require__(59074);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/validation/index.js + 6 modules
var validation = __webpack_require__(89965);
;// CONCATENATED MODULE: ./src/ForgotPasswordForm/form.js

const initialState = {
    email: ""
};
const schema = {
    email: [
        [
            validation/* required */.C1,
            "errors.EMAIL_REQUIRED"
        ],
        [
            (0,validation/* isCorrectEmailLen */.jh)(64),
            "errors.EMAIL_INVALID_LENGTH"
        ],
        [
            validation/* isSimpleEmail */.QZ,
            "errors.WRONG_EMAIL"
        ]
    ]
};
const validateForm = (0,validation/* default */.ZP)(schema);

// EXTERNAL MODULE: ./src/utils/useResultStatus/index.js
var useResultStatus = __webpack_require__(4116);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
// EXTERNAL MODULE: ./src/services/customer.js + 9 modules
var customer = __webpack_require__(81396);
// EXTERNAL MODULE: ./src/apollo/operation-errors.js
var operation_errors = __webpack_require__(99092);
// EXTERNAL MODULE: ./src/routes.js + 1 modules
var routes = __webpack_require__(72578);
// EXTERNAL MODULE: ./src/nprogress.js
var nprogress = __webpack_require__(24753);
;// CONCATENATED MODULE: ./src/ForgotPasswordForm/action.js






const forgotPassword = (form)=>customer/* getCustomerForgotPasswordLink */.DY(form).then((0,routes/* gotoPath */.pR)(routes/* default.forgotPasswordSuccess */.ZP.forgotPasswordSuccess)).catch((0,fn/* mapErrors */.wc)(operation_errors/* default */.ZP));
/* harmony default export */ var ForgotPasswordForm_action = ((0,pipe/* default */.Z)(forgotPassword, (0,nprogress/* withLoading */.VT)("forgot-password")));

;// CONCATENATED MODULE: ./src/ForgotPasswordForm/index.js












function ForgotPasswordForm() {
    const [t] = (0,i18/* useLocale */.bU)("forgot-password-form");
    const [forgotPasswordAction, isRequestProcessing] = (0,useTracking/* default */.ZP)(ForgotPasswordForm_action, useTracking/* CATCH */.av);
    const [action, { errors  }, resetResult] = (0,useResultStatus/* default */.Z)(forgotPasswordAction);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isRequestProcessing && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmartForm/* default */.ZP, {
                textRender: t,
                initialState: initialState,
                validateForm: validateForm,
                action,
                onTouched: resetResult,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartForm/* default.Field */.ZP.Field, {
                        label: "EMAIL",
                        name: "email",
                        type: "email",
                        disabled: isRequestProcessing,
                        error: errors.message,
                        fieldClassName: "mb-8",
                        required: true,
                        "data-qa-selector": "forgot-password-email-input"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                            spacing: {
                                mt: 4,
                                mb: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                                sx: {
                                    textAlign: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    type: "submit",
                                    disabled: isRequestProcessing,
                                    "data-qa-selector": "forgot-password-submit-button",
                                    children: t("SUBMIT")
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var src_ForgotPasswordForm = (ForgotPasswordForm);

// EXTERNAL MODULE: ./src/AppError/index.js + 10 modules
var AppError = __webpack_require__(38209);
// EXTERNAL MODULE: ./src/utils/redirectIf/index.js
var redirectIf = __webpack_require__(12675);
// EXTERNAL MODULE: ./src/services/auth.js + 4 modules
var auth = __webpack_require__(5803);
// EXTERNAL MODULE: ./locales/forgot-password-page/index.js
var forgot_password_page = __webpack_require__(1943);
var forgot_password_page_default = /*#__PURE__*/__webpack_require__.n(forgot_password_page);
;// CONCATENATED MODULE: ./pages/auth/forgot-password/index.js















const ForgotPasswordPage = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("forgot-password-form");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
                title: t("PAGE_TITLE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleTemplate/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        "data-qa-selector": "forgot-password-page-title",
                        children: t("FORM_TITLE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                        "data-qa-selector": "forgot-password-form-subtitle",
                        children: t("SUBTITLE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src_ForgotPasswordForm, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var forgot_password = ((0,pipe/* default */.Z)(ForgotPasswordPage, (0,i18/* WithLocale */._t)({
    resources: (forgot_password_page_default())
}), (0,redirectIf/* default */.ZP)(auth/* isAuthorized */.QO, (0,routes/* toReturnUrl */.YT)(routes/* default.myAccount */.ZP.myAccount)), AppError/* withErrorHandling */.b));


/***/ }),

/***/ 76965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ((0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
    message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
    stack: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.arrayOf)(prop_types__WEBPACK_IMPORTED_MODULE_0__.string),
    originalError: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        name: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
        code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
        message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string
    })
}));


/***/ }),

/***/ 38209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ src_AppError; },
  "b": function() { return /* binding */ withErrorHandling; }
});

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ForceErrorHoC/index.js
var ForceErrorHoC = __webpack_require__(4354);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./src/AppError/error-prop-type.js
var error_prop_type = __webpack_require__(76965);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./src/routes.js + 1 modules
var routes = __webpack_require__(72578);
;// CONCATENATED MODULE: ./src/AppError/Error400.js







const Error400 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("400");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("BAD_REQUEST")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error400 = (Error400);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/global-context/hook.js
var hook = __webpack_require__(63841);
;// CONCATENATED MODULE: ./src/utils/nav-hooks/useCurrentPath.js


/** @type {() => string} */ function useCurrentPath() {
    const context = (0,hook/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const { asPath  } = router || context;
    return asPath;
}
/* harmony default export */ var nav_hooks_useCurrentPath = (useCurrentPath);

;// CONCATENATED MODULE: ./src/AppError/Error401.js








const Error401 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("401");
    const currentPath = nav_hooks_useCurrentPath();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_AUTHORIZED")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: "".concat(routes/* default.logout */.ZP.logout, "?returnUrl=").concat(encodeURIComponent(currentPath)),
                        children: t("SIGN_IN")
                    }),
                    " ",
                    t("WITH_DIFFERENT_ACCOUNT"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error401 = (Error401);

;// CONCATENATED MODULE: ./src/AppError/Error403.js







const Error403 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("403");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_PERMITTED")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error403 = (Error403);

;// CONCATENATED MODULE: ./src/AppError/Error404.js





const Error404 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("404");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_FOUND")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: t("DESC")
            })
        ]
    });
};
/* harmony default export */ var AppError_Error404 = (Error404);

;// CONCATENATED MODULE: ./src/AppError/Error500.js







const Error500 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("500");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("SOMETHING_WENT_WRONG")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error500 = (Error500);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(89032);
;// CONCATENATED MODULE: ./src/AppError/ErrorDetails.js






const ErrorDetails = (param)=>/*#__PURE__*/ {
    let { error  } = param;
    return (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
        mx: true,
        md: 10,
        lg: 8,
        center: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "panel ".concat(color/* bgColorBlack */.ZH),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: "".concat(color/* colorWhite */.A2, " px-5 py-5"),
                children: JSON.stringify(error, null, 2)
            })
        })
    });
};
ErrorDetails.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_ErrorDetails = (config/* publicConfig.DEBUG_MODE */.mn.DEBUG_MODE ? ErrorDetails : ()=>null);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Layout/index.js + 1 modules
var Layout = __webpack_require__(71412);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js + 3 modules
var SimpleTemplate = __webpack_require__(35449);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Header/index.js + 6 modules
var Header = __webpack_require__(38529);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./src/prerendered-logo.js
var prerendered_logo = __webpack_require__(25476);
;// CONCATENATED MODULE: ./src/AppError/ErrorLayout.js









/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode }>} */ const ErrorLayout = (param)=>/*#__PURE__*/ {
    let { children , extra  } = param;
    return (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default.Header */.Z.Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                    logo: prerendered_logo/* default */.ZP
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default.Body */.Z.Body, {
                className: color/* bgColorBlack2 */.vk,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleTemplate/* default */.Z, {
                        children: children
                    }),
                    extra && /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                        className: "pt-9 pt-9--md pb-18 pb-18--md",
                        children: extra
                    })
                ]
            })
        ]
    });
};
ErrorLayout.propTypes = {
    children: prop_types.node,
    extra: prop_types.node
};
/* harmony default export */ var AppError_ErrorLayout = (ErrorLayout);

// EXTERNAL MODULE: ./src/AppError/mapGraphQLErrors.js
var mapGraphQLErrors = __webpack_require__(20522);
// EXTERNAL MODULE: ./locales/errors-page/index.js
var errors_page = __webpack_require__(88054);
var errors_page_default = /*#__PURE__*/__webpack_require__.n(errors_page);
;// CONCATENATED MODULE: ./src/AppError/AppError.js














const errorComponents = {
    400: AppError_Error400,
    401: AppError_Error401,
    403: AppError_Error403,
    404: AppError_Error404
};
const AppError = (param)=>{
    let { error  } = param;
    const { code  } = error;
    const ErrorComponent = errorComponents[code] || AppError_Error500;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorLayout, {
        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorDetails, {
            error: error
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent, {
            error: error
        })
    });
};
AppError.getInitialProps = (context)=>{
    const { err , res  } = context;
    const appErr = (0,mapGraphQLErrors/* default */.ZP)(err);
    if (res) {
        res.statusCode = appErr.code;
    }
    if (appErr.code >= 500 && appErr.originalError != null) throw appErr.originalError;
    return {
        error: appErr.toSerializable()
    };
};
AppError.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_AppError = ((0,pipe/* default */.Z)(AppError, (0,i18/* WithLocale */._t)({
    resources: (errors_page_default())
})));

// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(18499);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./src/graphql-local/unexpectedError/index.js + 3 modules
var unexpectedError = __webpack_require__(51041);
// EXTERNAL MODULE: ./src/sentry.js + 69 modules
var sentry = __webpack_require__(51720);
// EXTERNAL MODULE: ./src/utils/nav-hooks/useQueryString.js
var useQueryString = __webpack_require__(88046);
;// CONCATENATED MODULE: ./src/AppError/withErrorHandlingHoC.js










const withErrorHandlingHoC = (Component)=>{
    const WithErrorHandling = (param)=>{
        let { error , ...props } = param;
        const { data  } = (0,react_hooks_esm/* useQuery */.aM)(unexpectedError/* getUnexpectedError */.c);
        const asPath = nav_hooks_useCurrentPath();
        const query = (0,useQueryString/* default */.Z)();
        react.useEffect(()=>{
            if ((data === null || data === void 0 ? void 0 : data.unexpectedError) == null) return;
            (0,sentry/* notifySentry */.Yw)(ApplicationError/* default.of */.Z.of(data.unexpectedError), {
                asPath,
                query
            });
        }, [
            data === null || data === void 0 ? void 0 : data.unexpectedError
        ]);
        if (error == null && (data === null || data === void 0 ? void 0 : data.unexpectedError) == null) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                ...props
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_AppError, {
            error: error || ApplicationError/* default.of */.Z.of(data.unexpectedError)
        });
    };
    WithErrorHandling.propTypes = AppError_AppError.propTypes;
    WithErrorHandling.getInitialProps = (context)=>{
        try {
            const props = Component.getInitialProps ? Component.getInitialProps(context) : {};
            return (0,fn/* isPromise */.tI)(props) ? props.catch((err)=>AppError_AppError.getInitialProps({
                    ...context,
                    err
                })) : props;
        } catch (err) {
            return AppError_AppError.getInitialProps({
                ...context,
                err
            });
        }
    };
    return WithErrorHandling;
};
/* harmony default export */ var AppError_withErrorHandlingHoC = (withErrorHandlingHoC);

;// CONCATENATED MODULE: ./src/AppError/index.js





const withErrorHandling = (0,fn/* compose */.qC)(AppError_withErrorHandlingHoC, config/* publicConfig.DEBUG_MODE */.mn.DEBUG_MODE ? (0,ForceErrorHoC/* withForceError */.B)("throw") : fn/* idX */.Yr);
/* harmony default export */ var src_AppError = (AppError_AppError);


/***/ }),

/***/ 20522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I3": function() { return /* binding */ isNotFound; },
/* harmony export */   "_j": function() { return /* binding */ isNotAuthorized; }
/* harmony export */ });
/* unused harmony exports isGraphQLErrorIn, isBadRequest, isNotPermitted, isNetwork */
/* harmony import */ var _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66651);
/* eslint-disable no-nested-ternary, prettier/prettier */ 
const isGraphQLErrorIn = function() {
    for(var _len = arguments.length, codes = new Array(_len), _key = 0; _key < _len; _key++){
        codes[_key] = arguments[_key];
    }
    return (param)=>{
        let { graphQLErrors  } = param;
        return graphQLErrors && graphQLErrors.length && codes.includes(graphQLErrors[0].code);
    };
};
const isBadRequest = isGraphQLErrorIn(400, "INTERNAL_SERVER_ERROR");
const isNotAuthorized = isGraphQLErrorIn(401);
const isNotFound = isGraphQLErrorIn(400, 404);
const isNotPermitted = isGraphQLErrorIn(403);
const isNetwork = (param)=>{
    let { networkError  } = param;
    return networkError != null;
};
const mapGraphQLErrors = (error)=>isBadRequest(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 400) : isNotAuthorized(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 401) : isNotPermitted(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 403) : isNotFound(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 404) : isNetwork(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error) : _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"].of */ .Z.of(error);
/* harmony default export */ __webpack_exports__["ZP"] = (mapGraphQLErrors);


/***/ }),

/***/ 99092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L6": function() { return /* binding */ getExceptionFields; },
/* harmony export */   "ZU": function() { return /* binding */ GraphQLNetworkException; }
/* harmony export */ });
/* unused harmony exports netError, gqlError */
/* harmony import */ var _utils_exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28813);

const getMessage = (param)=>{
    let { extensions: { errors  } , message  } = param;
    return (errors === null || errors === void 0 ? void 0 : errors.length) > 0 ? errors[0].message || message : message;
};
const getExtensionsErrors = (param)=>{
    let { path , code , extensions: { errors  }  } = param;
    return (errors === null || errors === void 0 ? void 0 : errors.length) > 0 ? errors.map((error)=>"graphql:".concat(path, ".").concat(error.type ? error.message : code)) : [
        "graphql:".concat(path, ".").concat(code)
    ];
};
const getExceptionFields = (originalError)=>[
        getMessage(originalError),
        originalError.code,
        getExtensionsErrors(originalError),
        originalError
    ];
/** @TODO: Extract class to ActionFailException */ class GraphQLNetworkException extends _utils_exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
}
const netError = (param)=>{
    let { networkError  } = param;
    return networkError ? new GraphQLNetworkException(networkError.message, networkError.code) : null;
};
const gqlError = (param)=>{
    let { graphQLErrors  } = param;
    return (graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors.length) > 0 ? new _utils_exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(...getExceptionFields(graphQLErrors[0])) : null;
};
const getOperationError = (err)=>err instanceof _utils_exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z ? err : gqlError(err) || netError(err);
/* harmony default export */ __webpack_exports__["ZP"] = (getOperationError);


/***/ }),

/***/ 90547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gc": function() { return /* binding */ currentCustomerPropTypes; },
/* harmony export */   "Qc": function() { return /* binding */ readCurrentCustomer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4969);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	query getCurrentCustomer {\n		getCurrentCustomer {\n			email\n			firstName\n			lastName\n			address1\n			address2\n			address3\n			countryID\n			state\n			city\n			zipCode\n			phone\n			company\n		}\n	}\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["ZP"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject()));
const currentCustomerPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_2__.shape)({
    email: prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
    firstName: prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
    lastName: prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
    address1: prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
    address2: prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
    address3: prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
    countryID: prop_types__WEBPACK_IMPORTED_MODULE_2__.number,
    state: prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
    city: prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
    zipCode: prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
    phone: prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
    company: prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
    error: prop_types__WEBPACK_IMPORTED_MODULE_2__.string
});
const readCurrentCustomer = (param)=>{
    let { data  } = param;
    return data && data.getCurrentCustomer;
};


/***/ }),

/***/ 81396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z6": function() { return /* binding */ customer_addAlternateAdmin; },
  "Zl": function() { return /* binding */ customer_getCurrentCustomer; },
  "DY": function() { return /* binding */ customer_getCustomerForgotPasswordLink; },
  "OB": function() { return /* binding */ getPasswordResetIdStatus; },
  "X0": function() { return /* binding */ customer_removeAlternateAdmin; },
  "c0": function() { return /* binding */ resetPassword; }
});

// UNUSED EXPORTS: changeEmail, changePassword

// EXTERNAL MODULE: ./src/apollo/index.js + 14 modules
var apollo = __webpack_require__(75469);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 15 modules
var lib = __webpack_require__(4969);
;// CONCATENATED MODULE: ./src/graphql/mutations/getCustomerForgotPasswordLink.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation getCustomerForgotPasswordLinkMutation($email: String!) {\n		getCustomerForgotPasswordLink(email: $email)\n	}\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var getCustomerForgotPasswordLink = ((0,lib/* default */.ZP)(_templateObject()));

;// CONCATENATED MODULE: ./src/graphql/mutations/setCustomerPasswordByPasswordResetID.js

function setCustomerPasswordByPasswordResetID_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation setCustomerPasswordByPasswordResetID($passwordResetID: String!, $password: String!) {\n		setCustomerPasswordByPasswordResetID(passwordResetID: $passwordResetID, password: $password)\n	}\n"
    ]);
    setCustomerPasswordByPasswordResetID_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var setCustomerPasswordByPasswordResetID = ((0,lib/* default */.ZP)(setCustomerPasswordByPasswordResetID_templateObject()));

// EXTERNAL MODULE: ./src/graphql/queries/getCurrentCustomer.js
var getCurrentCustomer = __webpack_require__(90547);
;// CONCATENATED MODULE: ./src/graphql/queries/getCustomerPasswordResetIdStatus.js

function getCustomerPasswordResetIdStatus_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	query getCustomerPasswordResetIdStatus($passwordResetID: String!) {\n		getCustomerPasswordResetIdStatus(passwordResetID: $passwordResetID) {\n			exists\n			isExpired\n		}\n	}\n"
    ]);
    getCustomerPasswordResetIdStatus_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var getCustomerPasswordResetIdStatus = ((0,lib/* default */.ZP)(getCustomerPasswordResetIdStatus_templateObject()));
const readPasswordResetIdStatus = (param)=>{
    let { data  } = param;
    return data && data.getCustomerPasswordResetIdStatus;
};

;// CONCATENATED MODULE: ./src/graphql/mutations/changeCustomerPassword.js

function changeCustomerPassword_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation changeCustomerPassword($oldPassword: String!, $newPassword: String!) {\n		changeCustomerPassword(oldPassword: $oldPassword, newPassword: $newPassword)\n	}\n"
    ]);
    changeCustomerPassword_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var mutations_changeCustomerPassword = ((0,lib/* default */.ZP)(changeCustomerPassword_templateObject()));

;// CONCATENATED MODULE: ./src/graphql/mutations/changeCustomerEmail.js

function changeCustomerEmail_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation changeCustomerEmail($newEmail: String!, $password: String!) {\n		changeCustomerEmail(newEmail: $newEmail, password: $password)\n	}\n"
    ]);
    changeCustomerEmail_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var mutations_changeCustomerEmail = ((0,lib/* default */.ZP)(changeCustomerEmail_templateObject()));

;// CONCATENATED MODULE: ./src/graphql/mutations/addAlternateAdmin.js

function addAlternateAdmin_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation currentUser_addSubscriptionAdminEmail($subscriptionID: Int!, $email: String!) {\n		currentUser_addSubscriptionAdminEmail(subscriptionID: $subscriptionID, email: $email)\n	}\n"
    ]);
    addAlternateAdmin_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var addAlternateAdmin = ((0,lib/* default */.ZP)(addAlternateAdmin_templateObject()));

;// CONCATENATED MODULE: ./src/graphql/mutations/removeAlternateAdmin.js

function removeAlternateAdmin_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation currentUser_removeSubscriptionAdminEmail($subscriptionID: Int!, $email: String!) {\n		currentUser_removeSubscriptionAdminEmail(subscriptionID: $subscriptionID, email: $email)\n	}\n"
    ]);
    removeAlternateAdmin_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var removeAlternateAdmin = ((0,lib/* default */.ZP)(removeAlternateAdmin_templateObject()));

// EXTERNAL MODULE: ./src/utils/exceptions/ActionFailException/index.js
var ActionFailException = __webpack_require__(28813);
;// CONCATENATED MODULE: ./src/utils/exceptions/customer/AlreadyExistsException.js

class CustomerAlreadyExistsException extends ActionFailException/* default */.Z {
}

;// CONCATENATED MODULE: ./src/utils/exceptions/customer/NotFoundException.js

class CustomerNotFoundException extends ActionFailException/* default */.Z {
}

// EXTERNAL MODULE: ./src/apollo/operation-errors.js
var operation_errors = __webpack_require__(99092);
;// CONCATENATED MODULE: ./src/services/customer.js












const catchCustomerServiceExceptions = (apolloError)=>{
    const error = apolloError.graphQLErrors[0];
    if (error && error.code === 406) {
        throw new CustomerAlreadyExistsException(...(0,operation_errors/* getExceptionFields */.L6)(error));
    }
    if (error && error.code === 404) {
        throw new CustomerNotFoundException(...(0,operation_errors/* getExceptionFields */.L6)(error));
    }
    throw apolloError;
};
const getPasswordResetIdStatus = (context)=>{
    const passwordResetID = context.query.key;
    return (0,apollo/* default */.Z)(context).query({
        query: getCustomerPasswordResetIdStatus,
        variables: {
            passwordResetID
        }
    }).then(readPasswordResetIdStatus).catch(catchCustomerServiceExceptions);
};
const customer_getCustomerForgotPasswordLink = (param)=>{
    let { email  } = param;
    return (0,apollo/* default */.Z)().mutate({
        mutation: getCustomerForgotPasswordLink,
        variables: {
            email
        }
    }).then(()=>true).catch(catchCustomerServiceExceptions);
};
const resetPassword = (param)=>{
    let { passwordResetID , password  } = param;
    return (0,apollo/* default */.Z)().mutate({
        mutation: setCustomerPasswordByPasswordResetID,
        variables: {
            passwordResetID,
            password
        }
    }).then(()=>true).catch(catchCustomerServiceExceptions);
};
const changePassword = (param)=>{
    let { currentPassword , newPassword  } = param;
    return apolloClient().mutate({
        mutation: changeCustomerPassword,
        variables: {
            oldPassword: currentPassword,
            newPassword
        }
    }).then(()=>true).catch(catchCustomerServiceExceptions);
};
const changeEmail = (param)=>{
    let { email , password  } = param;
    return apolloClient().mutate({
        mutation: changeCustomerEmail,
        variables: {
            newEmail: email,
            password
        }
    }).then(()=>true).catch(catchCustomerServiceExceptions);
};
const customer_getCurrentCustomer = (param)=>{
    let { req , res  } = param;
    return (0,apollo/* default */.Z)({
        req,
        res
    }).query({
        query: getCurrentCustomer/* default */.ZP
    }).then(getCurrentCustomer/* readCurrentCustomer */.Qc).catch(catchCustomerServiceExceptions);
};
const customer_addAlternateAdmin = (param)=>{
    let { subscriptionID , email  } = param;
    return (0,apollo/* default */.Z)().mutate({
        mutation: addAlternateAdmin,
        variables: {
            subscriptionID,
            email
        }
    }).then(()=>email).catch(catchCustomerServiceExceptions);
};
const customer_removeAlternateAdmin = (subscriptionID, email)=>(0,apollo/* default */.Z)().mutate({
        mutation: removeAlternateAdmin,
        variables: {
            subscriptionID,
            email
        }
    }).then(()=>true).catch(catchCustomerServiceExceptions);


/***/ }),

/***/ 28813:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
class ActionFailException extends Error {
    /** @constructor
	 * @type {(message: string, code: null | string | number, stack: string[], originalError: Error)}
	 */ constructor(message, code = null, stack = [], originalError = {}){
        super("ActionFailException");
        this.name = this.constructor.name;
        this.code = code;
        this.message = message;
        /** @TODO: rename `stack` field to `details` */ this.stack = stack;
        this.originalError = originalError;
        this.localeMessage = this.stack[0] || this.message;
    }
}
/* harmony default export */ __webpack_exports__["Z"] = (ActionFailException);


/***/ }),

/***/ 88046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _insightfulscience_smart_react_url_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89333);
/* harmony import */ var _global_context_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63841);




function useQueryString() {
    const context = (0,_global_context_hook__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { asPath  } = router || context;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>(0,_insightfulscience_smart_react_url_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(asPath), [
        asPath
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useQueryString);


/***/ }),

/***/ 4116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_shared_utils_async_fallback__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37894);
/* harmony import */ var _insightfulscience_shared_utils_async_then__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86594);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10455);
/* harmony import */ var _exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28813);





const actionFallback = (setResultStatus)=>(0,_insightfulscience_shared_utils_async_fallback__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((err)=>{
        if (!(err instanceof _exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)) {
            // rethrowing err if it's not an ActionFailException
            throw err;
        }
        // suppressing ActionFailException
        setResultStatus({
            errors: err,
            hasErrors: true
        });
    });
const actionSuccess = (setResultStatus)=>(0,_insightfulscience_shared_utils_async_then__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((result)=>{
        setResultStatus({
            result,
            errors: {},
            hasErrors: false
        });
        return result;
    });
const actionEnhancer = (setResultStatus)=>(0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .compose */ .qC)(actionFallback(setResultStatus), actionSuccess(setResultStatus));
const getInitialState = ()=>({
        errors: {},
        hasErrors: false,
        result: undefined
    });
const useUniEffect = react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
function useResultStatus(action) {
    const unmounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const [resultStatus, setResultStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getInitialState);
    const statusRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    statusRef.current = resultStatus;
    useUniEffect(()=>()=>{
            unmounted.current = true;
        }, []);
    const updateResultStatus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((result)=>{
        if (unmounted.current) return;
        setResultStatus(result);
    }, []);
    const withResultStatus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>actionEnhancer(updateResultStatus)(// fallback decorator
        function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            setResultStatus(getInitialState);
            return action(...args);
        }), [
        action
    ]);
    const resetResult = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        if (statusRef.current.hasErrors) {
            // if there is no error, so there is no need to reset status
            setResultStatus(getInitialState);
        }
    }, []);
    return [
        withResultStatus,
        resultStatus,
        resetResult
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useResultStatus);


/***/ }),

/***/ 94746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74229);




const SimpleTemplateDescription = (param)=>{
    let { className ="" , center =true , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        size: "l",
        center: center,
        className: className,
        ...props,
        children: children
    });
};
SimpleTemplateDescription.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleTemplateDescription);


/***/ }),

/***/ 70504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42866);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2349);







const SimpleTemplateTitle = (param)=>{
    let { sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .tF
    } , className ="" , size ="xl" , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        Tag: "h1",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)(...(0,_props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* .deepMergeProps */ .p)({
            fontSize: size,
            textAlign: "center"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* .deepMergeProps */ .p)({
            mb: 6
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(spacing))), className),
        ...props,
        children: children
    });
};
SimpleTemplateTitle.propTypes = {
    ..._Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleTemplateTitle);


/***/ }),

/***/ 35449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SimpleTemplate_SimpleTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/Panel.js





const Panel = (param)=>{
    let { className ="" , shadow , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
        className: (0,classes/* classes */.S)("panel", shadow && "panel--shadow", className),
        ...props
    });
};
Panel.propTypes = {
    shadow: prop_types.bool,
    ...Block/* default.propTypes */.Z.propTypes
};
/* harmony default export */ var Panel_Panel = (Panel);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/SimpleTemplate.js










const SimpleTemplate = (param)=>{
    let { cellWidth =8 , mdCellWidth =10 , paddingTop ="pt-9 pt-9--md" , paddingBottom ="pb-18 pb-18--md" , panel =true , panelPaddingY =16 , panelUtility ={
        ...props_utility/* utilityProps */.Gm
    } , children , bgColor =color/* bgColorBlack2 */.vk , className ="" , shadow =true , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)(paddingTop, paddingBottom, !(utility && utility.bgColor) && bgColor, ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    md: mdCellWidth,
                    lg: cellWidth,
                    children: panel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Panel_Panel, {
                        shadow: shadow,
                        utility: panelUtility,
                        spacing: {
                            py: panelPaddingY
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                            mx: true,
                            px: true,
                            utility: {
                                justify: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                md: 10,
                                children: children
                            })
                        })
                    }) : children
                })
            })
        })
    });
};
SimpleTemplate.propTypes = {
    shadow: prop_types.bool,
    cellWidth: prop_types.number,
    mdCellWidth: prop_types.number,
    paddingTop: prop_types.string,
    paddingBottom: prop_types.string,
    panel: prop_types.bool,
    panelPaddingY: prop_types.number,
    panelUtility: props_utility/* utilityPropTypes */.pQ,
    children: prop_types.node.isRequired,
    bgColor: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    className: prop_types.string
};
/* harmony default export */ var SimpleTemplate_SimpleTemplate = (SimpleTemplate);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js



/***/ }),

/***/ 12985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const ContentContainer = (param)=>{
    let { mx =false , px =false , my =false , py =false , sm ="" , md ="" , lg ="" , center =false , containerClassName ="" , className ="" , isFluid =false , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
        className: containerClassName,
        isFluid: isFluid,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
            mx: mx,
            px: px,
            my: my,
            py: py,
            className: className,
            center: center,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                sm: sm,
                md: md,
                lg: lg,
                children: children
            })
        })
    });
};
ContentContainer.propTypes = {
    mx: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    px: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    my: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    py: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    containerClassName: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    isFluid: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentContainer);


/***/ }),

/***/ 37894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _fn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10455);

const fallback = (handler)=>(fn)=>{
        if (typeof handler !== "function") return fn;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            const theHandler = (err)=>handler(err, ...args);
            try {
                const result = fn(...args);
                return (0,_fn__WEBPACK_IMPORTED_MODULE_0__/* .isPromise */ .tI)(result) ? result.catch(theHandler) : result;
            } catch (err) {
                return theHandler(err);
            }
        };
    };
/* harmony default export */ __webpack_exports__["Z"] = (fallback);


/***/ }),

/***/ 66651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

class ApplicationError extends Error {
    toSerializable() {
        const { name , message , code , stack , originalError , tags  } = this;
        return {
            name,
            message,
            code,
            stack: typeof stack === "string" ? stack.split("\n") : stack,
            originalError: originalError ? {
                name: originalError.name,
                code: originalError.code,
                message: originalError.message
            } : null,
            tags
        };
    }
    toJSON() {
        return this.toSerializable();
    }
    constructor(originalError, code = 500, message = ApplicationError.defaultMessage[code], tags = null){
        super(message);
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "name", "ApplicationError");
        this.code = code;
        this.originalError = originalError;
        this.stack = (originalError === null || originalError === void 0 ? void 0 : originalError.stack) || new Error().stack;
        this.tags = tags;
    }
}
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "defaultMessage", {
    400: "Bad Request",
    401: "Not Authorized",
    403: "Not Permitted",
    404: "Not Found",
    500: "Internal Error"
});
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "of", (error)=>error instanceof ApplicationError ? error : new ApplicationError(error, error.code || 500, error.message));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "BadRequest", ()=>new ApplicationError(null, 400));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "NotAuthorized", ()=>new ApplicationError(null, 401));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "NotFound", ()=>new ApplicationError(null, 404));
/* harmony default export */ __webpack_exports__["Z"] = (ApplicationError);


/***/ }),

/***/ 4354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ withForceError; }
/* harmony export */ });
/* unused harmony export throwError */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10455);
/* harmony import */ var _url_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89333);
/* harmony import */ var _displayName__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75511);
/* harmony import */ var _ApplicationError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66651);







const getCurrentPath = (param)=>{
    let { asPath  } = param;
    return asPath;
};
const getQueryParam = function() {
    let paramName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "throw";
    return (pathname)=>(0,_url_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(pathname)[paramName];
};
const parseErrorParams = (wsParamValue)=>/(-?\d+)-([^-].*)/.exec(wsParamValue) || [];
const normalizeParams = (param)=>{
    let [, code, message] = param;
    return [
        code && parseInt(code, 10),
        message
    ];
};
const getErrorParamsFromPath = (paramName)=>(0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .compose */ .qC)(normalizeParams, parseErrorParams, getQueryParam(paramName), getCurrentPath);
const throwError = (getInitialProps, paramName)=>(context)=>{
        const [code, message] = getErrorParamsFromPath(paramName)(context);
        if (code == null) {
            return (0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .isFunc */ .Wl)(getInitialProps) ? getInitialProps(context) : {
                __throwError: true
            };
        }
        if (code < 0) throw new _ApplicationError__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(new Error("Server Side: ".concat(message)), -code, "Server Side: ".concat(message));
        return {
            errorToThrow: {
                code,
                message
            }
        };
    };
/** @type {(paramName: string) => <P extends {}>(Component: React.Component<P>) => React.FC<P>} */ const withForceErrorHOC = (paramName)=>(Component)=>{
        const ComponentWithThrowError = (param)=>{
            let { errorToThrow , ...props } = param;
            if (errorToThrow && "object" !== "undefined") throw new _ApplicationError__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(new Error("Client Side: ".concat(errorToThrow.message)), errorToThrow.code, "Client Side: ".concat(errorToThrow.message));
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                ...props
            });
        };
        ComponentWithThrowError.propTypes = {
            ...Component.propTypes,
            errorToThrow: (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.shape)({
                code: prop_types__WEBPACK_IMPORTED_MODULE_5__.number,
                message: prop_types__WEBPACK_IMPORTED_MODULE_5__.string
            })
        };
        ComponentWithThrowError.displayName = (0,_displayName__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("withForceError", Component);
        ComponentWithThrowError.getInitialProps = throwError(Component.getInitialProps, paramName);
        return ComponentWithThrowError;
    };
const withForceError = withForceErrorHOC;


/***/ }),

/***/ 73446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);




const PageTitle = (param)=>{
    let { title  } = param;
    return title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }, "title")
        ]
    }) : null;
};
PageTitle.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (PageTitle);


/***/ }),

/***/ 89333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11987);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(url__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97334);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(querystring__WEBPACK_IMPORTED_MODULE_1__);


const query = (path)=>querystring__WEBPACK_IMPORTED_MODULE_1___default().parse((0,url__WEBPACK_IMPORTED_MODULE_0__.parse)(path).query);
/* harmony default export */ __webpack_exports__["Z"] = (query);


/***/ }),

/***/ 42134:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"FORM_TITLE":"Set your password","PAGE_TITLE":"Forgot Password - SnapGene","EMAIL":"Email Address","SUBMIT":"Submit","SIGN_IN":"Already have an account? <a href=\\"/auth/login\\">login here</a>","SIGN_UP":"<a href=\\"/auth/login\\">Create new account</a>","SUBTITLE":"To set a new password, type the full email address you use to sign in to My Account.","errors":{"EMAIL_REQUIRED":"Please enter your email.","WRONG_EMAIL":"Please enter valid email.","EMAIL_INVALID_LENGTH":"Please enter valid email(up to 64 characters)."}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6319,5606,8124,8930,2458,3918,9774,2888,179], function() { return __webpack_exec__(25436), __webpack_exec__(49021); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);